'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2019 Adobe Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _WAMConstants = require('../constants/WAMConstants');

var _https = require('https');

var _https2 = _interopRequireDefault(_https);

var _platform = require('platform');

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommonUtil = function () {
	function CommonUtil() {
		_classCallCheck(this, CommonUtil);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
	}

	/** Get browser type **/


	// Singleton


	_createClass(CommonUtil, [{
		key: 'getBrowserType',
		value: function getBrowserType() {
			var ua = navigator.userAgent;
			var tem = void 0;
			var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
			if (/trident/i.test(M[1])) {
				tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
				return { name: 'IE', version: tem[1] || '' };
			}
			if (M[1] === 'Chrome') {
				tem = ua.match(/\bOPR|Edge\/(\d+)/);
				if (tem != null) {
					return { name: 'Opera', version: tem[1] };
				}
			}
			M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
			if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
				M.splice(1, 1, tem[1]);
			}

			// Refer - https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=CCHome&title=WAM+-+v2
			if (M[0] === 'Firefox' && M[1] > 54) {
				return { name: 'Firefox' };
			}
			if (M[0] === 'Chrome' && M[1] > 60) {
				return { name: 'Chrome' };
			}
			return { name: 'Unknown' };
		}

		/** to check if browser supports http ping */

	}, {
		key: 'isBrowserSupportedForHttpPing',
		value: function isBrowserSupportedForHttpPing() {
			var browserType = this.getBrowserType();
			if (browserType.name === 'Chrome' || browserType.name === 'Firefox') {
				return true;
			}
			return false;
		}

		/**
   * compareVersionNumbers compares two strings of dot separated integers such that we
   * return 1 if a > b
   * return -1 if a < b
   * return 0 if a === b
   * e.g. compareVersionNumbers(1.0, 1.0.1) returns -1,
   * compareVersionNumbers(2.0, 1.0.3) returns 1,
   * compareVersionNumbers(3.0, 3.0.0) returns 0
   */

	}, {
		key: 'compareVersionNumbers',
		value: function compareVersionNumbers(a, b) {
			var aParts = a.split('.').map(function (str) {
				return parseInt(str, 10);
			});
			var bParts = b.split('.').map(function (str) {
				return parseInt(str, 10);
			});
			var maxParts = aParts.length > bParts.length ? aParts : bParts;
			for (var i = 0; i < maxParts.length; i++) {
				if (aParts[i] === undefined) {
					aParts[i] = 0;
				} else if (bParts[i] === undefined) {
					bParts[i] = 0;
				}
				if (aParts[i] > bParts[i]) {
					return 1;
				} else if (aParts[i] < bParts[i]) {
					return -1;
				}
			}
			return 0;
		}
	}, {
		key: 'getFFCPassphrase',
		value: function getFFCPassphrase(FFCENV) {
			return new Promise(function (resolve, reject) {
				var request = _https2.default.request({
					hostname: _WAMConstants.FFCUrls.products[FFCENV].replace('https://', ''),
					path: '/adobe-ffc-external/core/v1/passphrase?passPhrase=' + new Date().getTime(),
					withCredentials: false
				}, function (res) {
					var data = '';
					res.on('data', function (chunk) {
						return data += chunk;
					});
					res.on('end', function () {
						return resolve(data);
					});
				});

				request.on('error', function (e) {
					reject(e);
				});

				request.end();
			});
		}
	}, {
		key: 'isVersionEnabled',
		value: function isVersionEnabled(versionObj) {
			var customEntry = false;
			try {
				customEntry = versionObj.platforms.platform[0]['custom-data']['custom-entry'];
			} catch (e) {}
			if (customEntry) {
				for (var k = 0; k < customEntry.length; ++k) {
					var customEntryObj = customEntry[k];
					if (customEntryObj.key === 'isVersionDisabled' && customEntryObj.value && customEntryObj.value[0] && typeof customEntryObj.value[0] === 'string' && customEntryObj.value[0].toLowerCase() === 'true') {
						return false;
						break;
					}
				}
			}
			return true;
		}
	}, {
		key: 'isAGreaterThanEqualToB',
		value: function isAGreaterThanEqualToB(versionA, versionB, compareMinorVersion) {
			if (versionA === Infinity) {
				return true;
			}
			if (versionB === Infinity) {
				return false;
			}

			var compareResult = void 0;
			if (!compareMinorVersion) {
				var splitVersion = versionA.split('.');
				splitVersion.pop();
				var versionAWithoutMinor = splitVersion.join('.');

				splitVersion = versionB.split('.');
				splitVersion.pop();
				var versionBWithoutMinor = splitVersion.join('.');

				compareResult = this.compareVersionNumbers(versionAWithoutMinor, versionBWithoutMinor);
				return compareResult === 1 || compareResult === 0;
			}

			compareResult = this.compareVersionNumbers(versionA, versionB);
			return compareResult === 1 || compareResult === 0;
		}
	}, {
		key: 'isMacOS',
		value: function isMacOS() {
			if (_platform2.default && _platform2.default.os && _platform2.default.os.family) {
				return _platform2.default.os.family.toLowerCase().includes('os x');
			}
			if (navigator.userAgent.toLowerCase().match('mac os x')) {
				return true;
			}
			return false;
		}
	}, {
		key: 'isWin',
		value: function isWin() {
			if (_platform2.default && _platform2.default.os && _platform2.default.os.family) {
				return _platform2.default.os.family.toLowerCase().includes('windows');
			}
			return navigator.appVersion.indexOf('Win') !== -1;
		}
	}, {
		key: 'isDeprecatedWinOS',
		value: function isDeprecatedWinOS() {
			var agent = navigator.userAgent.toLowerCase();
			var depricated = agent.match('Windows NT 5.2'.toLowerCase()) || agent.match('Windows NT 5.1'.toLowerCase()) || agent.match('Windows NT 5.0'.toLowerCase()) || agent.match('Windows NT 6.0'.toLowerCase());
			return depricated && depricated.length > 0;
		}
	}, {
		key: 'isDeprecatedMacOS',
		value: function isDeprecatedMacOS() {
			var macOS = this.getMacVersion();
			if (macOS && macOS !== null) {
				var macOSArr = macOS.split('.');
				return parseInt(macOSArr[0], 10) < 10 || macOSArr[0] === '10' && macOSArr[1] && parseInt(macOSArr[1], 10) < 11;
			}
			return false;
		}
	}, {
		key: 'is64bitWindows',
		value: function is64bitWindows() {
			if (window.navigator.cpuClass && window.navigator.cpuClass === 'x64') {
				return true;
			}
			if (window.navigator.platform.toLowerCase().indexOf('win64') >= 0) {
				return true;
			}
			return navigator.userAgent.match(/wow64|win64/i) !== null;
		}
	}, {
		key: 'getMacVersion',
		value: function getMacVersion() {
			var agent = navigator.userAgent.toLowerCase();
			// The agent string will contain info in a format like: "mac os x 10_7_4" or "mac os x 10_8"
			if (agent.match('mac os x')) {
				var versionMatch = agent.match(/mac os x (10[_|\.][0-9]+[_|\.][0-9]+)/); // eslint-disable-line no-useless-escape
				// let versionChar = '_';
				var version = void 0;

				if (!versionMatch || versionMatch.length === 0) {
					versionMatch = agent.match(/mac os x (10[_|\.][0-9]+)/); // eslint-disable-line no-useless-escape
					if (versionMatch instanceof Array) {
						versionMatch[1] += '.0';
					}
				}

				if (versionMatch && versionMatch.length > 0) {
					version = versionMatch[1];
					// versionChar = version.match(/10\./) ? '.' : '_';
					version = version.replace(/_/g, '.');
				}
				return version;
			}
			return null;
		}

		/***
   * CCD doesn't support http ping on following OSes. Hence they are considered as deprecated os for http ping.
   * Win 7,8,8.1(32 and 64 bit) and win 10 32 bit
   * Mac 10.11 and below
   * @returns {*}
   */

	}, {
		key: 'isDeprecatedOSForCCDHttpPing',
		value: function isDeprecatedOSForCCDHttpPing() {
			/**
    * This check is for the OSes mentioned in https://wiki.corp.adobe.com/display/CCEE/M1+Learnings+-+All+Apps+App+Picker
    * For these OSes we show a special screen
    */
			if (this.isWin()) {
				return _platform2.default.os.version === '8' || _platform2.default.os.version === '8.1' || _platform2.default.os.version === '7';
			} else if (this.isMacOS()) {
				var macOS = this.getMacVersion();
				if (macOS && macOS !== null) {
					var macOSArr = macOS.split('.');
					return macOSArr[0] === '10' && macOSArr[1] && macOSArr[1] === '11' || parseInt(macOSArr[0], 10) < 10 || macOSArr[0] === '10' && macOSArr[1] && parseInt(macOSArr[1], 10) < 11;
				}
			}
			return false;
		}

		/**
   * Extract userid from imsToken
   * @param {} imsToken 
   */

	}, {
		key: 'extractPayloadFromToken',
		value: function extractPayloadFromToken(imsToken) {
			if (!imsToken) {
				return false;
			}
			var imsTokenParts = imsToken.split(".");
			var imsTokenPayload = void 0;
			if (imsTokenParts && imsTokenParts.length > 2) {
				try {
					imsTokenPayload = JSON.parse(new Buffer(imsTokenParts[1], 'base64').toString('utf8'));
				} catch (err) {
					return false;
				}
			}
			return imsTokenPayload;
		}
	}]);

	return CommonUtil;
}();

exports.default = new CommonUtil();